<template>
    <div role="tabcard" class="tab-pane" id="new-selection">
        <div class="card card-default">
            <div class="card-header">
                <div class="d-inline-block card-header-content">
                    <div class="title">New material selection template</div>
                </div>
                <div class="d-inline-block float-left text-info mr-2">
                    <i class="fas fa-drafting-compass fa-lg"></i>
                </div>
                <div class="">Material selection templates are common selections you can use across multiple projects.</div>
            </div>
            <div class="card-body">
                <template-form v-bind:is-editing="false"></template-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role'],
        
        created: function() {
        },

        mounted: function() {
        },

        data: function() {
            return {};
        },

        computed: {
        },

        watch: {
        },

        methods: {
        }
    }
</script>
